import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

const LogoHikari = () => {
  const data = useStaticQuery(graphql`
    query {
      logoHikari: file(relativePath: { eq: "logo-hikari.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 300,
        width: 300,
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <Img fluid={data.logoHikari.childImageSharp.fluid} />
    </div>
  );
};

export default LogoHikari;
